import {useDialogContext} from "../../dialogs/hooks/useDialogContext";
import {EditKeyDialogStateData} from "../types/EditKeyDialogStateData";

export const useEditKeyDialog = () => useDialogContext<EditKeyDialogStateData>('edit-key');
